import * as React from "react";

import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button
} from "reactstrap";

import i18n from "i18n";

export interface ImportDialogProps {
  isOpen: boolean;
  onCancel: () => void;
  onImport: (scenarios: any[]) => void;
}
export interface ImportDialogState {}

export default class ImportDialog extends React.Component<
  ImportDialogProps,
  ImportDialogState
  > {

  private file: File | null;

  constructor(props: ImportDialogProps) {
    super(props);
    this.state = {};
    this.file = null;
  }

  private handleSubmit(event: any) {
    event.preventDefault();
    
    if (!this.file) {
      return;
    }
    
    let reader = new FileReader();

    reader.onload = (e) => {
      let text = reader.result;

      if (typeof text === "string") {
        this.props.onImport(JSON.parse(String(text)));
      }
    }

    reader.readAsText(this.file);
  }

  private uploadFile(event: any) {
    this.file = event.target.files[0];
  }

  render() {
    return (
      <Modal isOpen={this.props.isOpen}>
        <ModalHeader>
          {i18n.Scenarios.ImportDialog.Title}
        </ModalHeader>
        <ModalBody>
          <form onSubmit={(e) => this.handleSubmit(e)}>
            <input
              type="file"
              name="myFile"
              onChange={(e) => this.uploadFile(e)}
            />
            <button>{i18n.Scenarios.ImportDialog.ImportButton}</button>
          </form>
        </ModalBody>
        <ModalFooter>
          <Button
            color="default"
            onClick={() => {
              this.file = null;
              this.props.onCancel();
            }}
          >
            {i18n.Global.Edit.Cancel}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/designer/exportimport/importdialog.tsx